// Centralized config for cross-app navigation from the website -> the platform.

export const PLATFORM_URL = (
  import.meta.env.VITE_PLATFORM_URL || "http://localhost:8080"
).replace(/\/$/, "");
export const PLATFORM_ROUTES = {
  community: PLATFORM_URL,
  feeds: `${PLATFORM_URL}/feeds`,
  mentorship: `${PLATFORM_URL}/mentorship`,
  roadmaps: `${PLATFORM_URL}/roadmaps`,
  signup: `${PLATFORM_URL}/login?mode=signup`,
  login: `${PLATFORM_URL}/redirect?to=login`,
};
 
